import React from 'react'
import {Row, Col, Glyphicon, Grid} from 'react-bootstrap'
import {iconMap, randomKeyGenerator, finalCharacter, contactEmail, contactPhone, faqItems, characterSet} from './source'
import './styles.css'
class Support extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      selectedCharacter : ''
    }
  }

  componentWillMount () {
    this.props.getGlossary()
  }

  getSearchBar = () => (
    <Row className="center">
      <Col xs={12} sm={10} md={8} mdOffset={2} >
        <input className="hsg-input wide" type={'text'} placeholder={'Search HealthSetGo Support'}/>
      </Col>
      <br/>
      <br/>
      <br/>
    </Row>
  )

  getContactBlock = (header, description) => (
    <Col className='hsg-contact-block-item' key={randomKeyGenerator()} md={6} sm={6} xs={12}>
      <Row>
        <Col className='icon-item'>
          <Glyphicon glyph={iconMap[header]}/>
        </Col>
        <Col className='group-item'>
          <h4 className='header-item'>{header}</h4>
          <span className="description-item">
            {description}
          </span>
        </Col>
      </Row>
    </Col>
  )

  getContactUsBlock = (contactItems) => (
    <Row>
      <Col className='hsg-contact-block' xs={12} md={8} mdOffset={2}>
        <h3>Contact Us</h3><br/>
        <h4>HealthSetGo Support team is here to help from 10:00 AM to 6:00 PM IST, Monday through Friday.</h4>
        {contactItems.map(({header, description}) => this.getContactBlock(header, description))}
      </Col>
      <br/>
      <br/>
      <br/>
    </Row>
  )

  showFaqItem = ({question, answer}) => (
    <Col xs={12} sm={6} md={6} className="hsg-faq-item" key={randomKeyGenerator()}>
      <h4>{question}</h4>
      {answer}
    </Col>
  )

  getFaqBlock = (faqItems) => (
    <Row>
      <Col sm={12} md={8} mdOffset={2}>
        <h3 className="center">FAQs</h3><br/>
        {faqItems.map(faqItem=>this.showFaqItem(faqItem))}
      </Col>
    </Row>
  )

  getGlossaryKeyStyle = (characterIsSelected) => characterIsSelected ? "hsg-glossary-key-selected" : "hsg-glossary-key" 

  showCharacterButton = (character) => <p className={this.getGlossaryKeyStyle(this.state.selectedCharacter === character)} key={randomKeyGenerator()} onClick={()=>this.setState({selectedCharacter: finalCharacter(character)})}>{character}</p>

  showGlossaryItem = ({title, content, contentFirstLetter}) => (this.state.selectedCharacter.toLowerCase() === contentFirstLetter || !Boolean(this.state.selectedCharacter)) ? (
      <Col className="hsg-glossary-item" xs={12} sm={6} md={4} key={randomKeyGenerator()}>
        <h4>{title}</h4>
        <span>{content}</span>
      </Col>
    ) : null

  getMedicalGlossary = (characterSet, glossaryItems) => (
    <Row className="">
      <Col sm={12} md={8} mdOffset={2}>
        <h3 className="center">Medical Glossary</h3><br/>
        <span>With hundreds of medical terms to memorize, doctors certainly have their hands full as they learn the language of their profession. Here are the most commonly used medical postfixes and prefixes.</span><br/><br/>
        <Row className="hsg-glossary-key-group">
          {characterSet.map(character => this.showCharacterButton(character))}
        </Row><br/>
        <Row className="hsg-glossary-group">
          {glossaryItems.map(this.showGlossaryItem)}
        </Row>
      </Col>
    </Row>
  )

  render(){
    return (
      <Grid className="hsg-default-background">
        {this.getSearchBar()}
        {this.getContactUsBlock([contactEmail, contactPhone])}
        {this.getFaqBlock(faqItems)}
        <hr/>
        {this.getMedicalGlossary(characterSet, this.props.glossary)}
      </Grid>
    )
  }
}

export default Support


// WEBPACK FOOTER //
// ./src/Containers/SupportContainer/Component/Support.js